export default __webpack_public_path__ + "static/media/Squares_02.805b62cf.png";